import React from 'react';
import Input from 'blocks/Input';
import _ from 'lodash';
import {inject} from 'mobx-react';

@inject('alert')
@inject('workshopDetails')
export default class EnterAccessCode extends React.Component {

  state = {showInput: false, access_code: '', errors: ''};

  handleChange = e => {
    let newState = _.assign({}, this.state, e);
    this.setState(newState);
  };

  showInput = e => {
    e.preventDefault();
    this.setState({showInput: true})
  };

  handleSubmit = e => {
    e.preventDefault();
    this.props.sendAccessCode(this.state.access_code);
  };

  render() {
    return this.props.workshopDetails.workshop.with_access_code && !localStorage.getItem('haveAccess') ? (
      <div className="enter-coupon" style={{textAlign: 'center', marginBottom: 8}}>
        {!this.state.showInput ?
          <a
            href="#"
            onClick={this.showInput}
            className='btn prime bordered'
            // style={{fontSize: 15}}
          >
            Enter Access code
          </a> :
          <div className="row">
            <form onSubmit={this.handleSubmit}>
            <div className="col-7">
              <Input name="access_code"
                    type="text"
                    grey={true}
                    value={this.state.access_code}
                    handleChange={this.handleChange}
                    placeholder="Enter Access Code"
                    error={this.state.errors}/>
            </div>
            <div className="col-3 validate-wrap">
              <span className="btn prime bordered validate-button" onClick={this.handleSubmit}>
                Apply Access Code
              </span>
            </div>
            </form>
          </div>
        }
      </div>
    ) : null;
  }
}



// WEBPACK FOOTER //
// ./src/components/providers/online_workshop_details/EnterAccessCode.jsx